import { render, staticRenderFns } from "./VersionCheck.vue?vue&type=template&id=300f8b3c&"
import script from "./VersionCheck.vue?vue&type=script&lang=js&"
export * from "./VersionCheck.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "VersionCheck.vue"
export default component.exports